import css from "./NpcStats.module.css";

type NpcStats = {
  pAtk: number | null;
  pDef: number | null;
  mAtk: number | null;
  mDef: number | null;
  pSpd: number | null;
  mSpd: number | null;
  accuracy: number | null;
  evasion: number | null;
  pCritical: number | null;
  baseMovingSpeed: number[];
  con: number | null;
  dex: number | null;
  int: number | null;
  men: number | null;
  str: number | null;
  wit: number | null;
};

export function NpcStats(props: { npc: NpcStats; }) {
  const { npc } = props;
  return (
    <>
      <div className={css.root}>
        <div className={css.title}>Combat</div>
        <div className={css.plate}>
          <div style={{ width: "100%" }}>
            <table className={css.table}>
              <tbody>
                <tr>
                  <th>P. Atk.</th>
                  <td>{npc.pAtk}</td>
                  <th>M. Atk.</th>
                  <td>{npc.mAtk}</td>
                </tr>
                <tr>
                  <th>P. Def.</th>
                  <td>{npc.pDef}</td>
                  <th>M. Def.</th>
                  <td>{npc.mDef}</td>
                </tr>
                <tr>
                  <th>Accuracy</th>
                  <td>{npc.accuracy}</td>
                  <th>Evasion</th>
                  <td>{npc.evasion}</td>
                </tr>
                <tr>
                  <th>Criitical</th>
                  <td>{npc.pCritical}</td>
                  <th>Speed</th>
                  <td>{npc.baseMovingSpeed[1]}</td>
                </tr>
                <tr>
                  <th>Atk. Spd.</th>
                  <td>{npc.pSpd}</td>
                  <th>Cast. Spd.</th>
                  <td>{npc.mSpd}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className={css.root}>
        <div className={css.title}>Basic</div>
        <div className={css.plate}>
          <div style={{ width: "100%" }}>
            <table className={css.table}>
              <tbody>
                <tr>
                  <th>Str</th>
                  <td>{npc.str}</td>
                  <th>Dex</th>
                  <td>{npc.dex}</td>
                  <th>Con</th>
                  <td>{npc.con}</td>
                </tr>
                <tr>
                  <th>Int</th>
                  <td>{npc.int}</td>
                  <th>Wit</th>
                  <td>{npc.wit}</td>
                  <th>Men</th>
                  <td>{npc.men}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
